import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-dark" data-id="element-99">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 rounded-3xl p-8 md:p-12 shadow-lg border-2 border-green-500/30 text-center relative overflow-hidden" data-id="element-101">
          {/* Decorative seal background */}
          <div className="absolute -top-24 -right-24 w-64 h-64 bg-green-900/20 rounded-full blur-3xl -z-10" data-id="element-102"></div>

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-500/20 text-green-400 mb-8 shadow-inner border-4 border-green-500/30" data-id="element-103">
            <ShieldIcon className="w-12 h-12" data-id="element-104" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-105">
            GARANTÍA 100% SIN RIESGO
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-106">
            <p data-id="element-107">
              Si en los próximos{' '}
              <span className="font-bold text-green-400" data-id="element-108">7 días</span> sientes
              que este método no es para ti…
            </p>
            <p data-id="element-109">
              Simplemente envías un correo y te devolvemos el{' '}
              <span className="font-bold text-green-400" data-id="element-110">
                100% de tu dinero
              </span>
              .
            </p>
            <p className="text-gray-500 italic" data-id="element-111">
              Sin preguntas. Sin complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}